import React, { useEffect, useState, useCallback } from "react";
import panelApi from "../util/panelApi";
import modApi from "../util/moderationApi";

const Kanit = ({ row, onClose }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    panelApi.incKanit(row._id).then((r) => setD(r?.status ? r : { hata: r?.message || "Yüklenemedi" }));
  }, [row._id]);
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={onClose}>
      <div className="card" style={{ width: "min(640px,100%)", maxHeight: "88vh", overflow: "auto", margin: 0 }} onClick={(e) => e.stopPropagation()}>
        <div className="card-body">
          <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 8 }}>
            <b>Kanıt · son 50 mesaj</b>
            <button className="btn btn-light btn-sm" style={{ marginLeft: "auto" }} onClick={onClose}>Kapat</button>
          </div>
          <div style={{ fontSize: 13, color: "#6B7280", marginBottom: 8 }}>Şikâyet: “{row.message}”</div>
          {!d ? <div className="badu-empty">Yükleniyor…</div> : d.hata ? <div className="badu-empty">{d.hata}</div> : !d.rows.length ? <div className="badu-empty">İki taraf arasında mesaj yok. ({d.sikayetci} ↔ {d.hedef})</div> : (
            <>
              <div style={{ fontSize: 13, marginBottom: 6 }}><b>{d.sikayetci}</b> ↔ <b>{d.hedef}</b></div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {d.rows.map((m, i) => (
                  <div key={i} style={{ alignSelf: m.benim ? "flex-end" : "flex-start", maxWidth: "80%", background: m.benim ? "#EEF2FF" : "#F3F4F6", borderRadius: 10, padding: "6px 10px" }}>
                    <div style={{ fontSize: 11, color: "#6B7280" }}>{m.from} · {new Date(m.at).toLocaleString("tr-TR")}</div>
                    {m.type === 0 && m.image ? <img src={m.image.startsWith("http") ? m.image : ""} alt="" style={{ maxWidth: 200 }} /> : <div style={{ whiteSpace: "pre-wrap" }}>{m.text || (m.type === 4 ? "Hediye / emoji" : m.type === 5 ? "Arama" : "—")}</div>}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const ComplaintQueue = () => {
  const [kanit, setKanit] = useState(null);
  const [tab, setTab] = useState("open");
  const [rows, setRows] = useState([]);
  const [breached, setBreached] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await modApi.complaints(tab === "solved");
    if (res?.status) {
      setRows(res.complaints || []);
      setBreached(res.breached || 0);
    } else {
      setRows([]);
      setBreached(0);
    }
    setLoading(false);
  }, [tab]);

  useEffect(() => {
    load();
  }, [load]);

  const resolve = async (row) => {
    const outcome = window.prompt(
      "Şikayet nasıl sonuçlandı? (işlem günlüğüne yazılacak)\n\nör: içerik kaldırıldı, host uyarıldı, hesap engellendi",
      ""
    );
    if (outcome === null) return;

    const res = await modApi.resolveComplaint(row._id, outcome);
    if (res?.status) load();
    else window.alert(res?.message || "İşlem tamamlanamadı.");
  };

  const who = (row) =>
    row.hostId?.name || row.userId?.name || row.contact || "Bilinmiyor";

  return (
    <>
      <div className="badu-page-head">
        <div>
          <h4>Şikayet Kuyruğu</h4>
          <div className="sub">
            App Store kuralı: uygunsuz içerik bildirimlerine 24 saat içinde müdahale edilmeli.
          </div>
        </div>
        <div className="btn-group btn-group-sm">
          <button
            type="button"
            className="btn"
            onClick={() => setTab("open")}
            style={{
              background: tab === "open" ? "#1E40AF" : "#FFF",
              color: tab === "open" ? "#FFF" : "#6B7280",
              border: "1px solid #E7EAF0",
            }}
          >
            Açık
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => setTab("solved")}
            style={{
              background: tab === "solved" ? "#1E40AF" : "#FFF",
              color: tab === "solved" ? "#FFF" : "#6B7280",
              border: "1px solid #E7EAF0",
            }}
          >
            Çözülen
          </button>
        </div>
      </div>

      {tab === "open" && breached > 0 && (
        <div
          className="card"
          style={{ borderColor: "#F3C5BF", background: "#FDECEA", marginBottom: 12 }}
        >
          <div className="card-body" style={{ padding: "11px 15px" }}>
            <b style={{ color: "#A8231A" }}>
              {breached} şikayet 24 saati aştı.
            </b>{" "}
            <span style={{ color: "#7A3F39", fontSize: 13 }}>
              Bunlar App Store uyum riski — önce bunları kapat.
            </span>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Kim</th>
                  <th>Şikayet</th>
                  <th>İletişim</th>
                  <th>Yaş</th>
                  <th>Durum</th>
                  {tab === "open" && <th>İşlem</th>}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6">
                      <div className="badu-empty">Yükleniyor…</div>
                    </td>
                  </tr>
                ) : rows.length === 0 ? (
                  <tr>
                    <td colSpan="6">
                      <div className="badu-empty">
                        {tab === "open" ? "Açık şikayet yok." : "Çözülmüş şikayet yok."}
                      </div>
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => (
                    <tr key={row._id}>
                      <td><b>{who(row)}</b></td>
                      <td style={{ maxWidth: 380, whiteSpace: "normal" }}>
                        {row.message || "—"}
                      </td>
                      <td>{row.contact || "—"}</td>
                      <td>
                        {row.ageHours < 1
                          ? "<1 sa"
                          : row.ageHours < 24
                          ? `${Math.round(row.ageHours)} sa`
                          : `${Math.floor(row.ageHours / 24)} gün`}
                      </td>
                      <td>
                        {row.isSolved ? (
                          <span className="badu-chip ok">Çözüldü</span>
                        ) : row.slaBreached ? (
                          <span className="badu-chip bad">24sa aşıldı</span>
                        ) : (
                          <span className="badu-chip wait">Bekliyor</span>
                        )}
                      </td>
                      {tab === "open" && (
                        <td>
                          <button type="button" className="btn btn-outline-secondary mr-2" onClick={() => setKanit(row)}>
                            Kanıt
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => resolve(row)}
                          >
                            Çözüldü işaretle
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {kanit && <Kanit row={kanit} onClose={() => setKanit(null)} />}
    </>
  );
};

export default ComplaintQueue;
